<template>
  <TickerPopover
    :title="$t('Notification')"
    :width="360"
    :left="left"
    :arrow-left="arrowLeft"
    @close="$emit('close')"
  >
    <ul class="notification-popover__list">
      <li
        v-for="(notification, index) in announcements"
        :key="`${index}${notification.publishDateTime}`"
        class="notification-popover__item"
        :class="{ latest: index === 0 }"
      >
        <div class="notification-popover__time">{{ renderDateTime(notification.publishDateTime) }}</div>
        <p class="notification-popover__message">{{ notification.message }}</p>
      </li>
    </ul>
  </TickerPopover>
</template>

<script>
import { mapGetters } from 'vuex';
import TickerPopover from '@/components/desktop/ticker-popover.vue';

/*
 * The desktop announcement list, opened from the ticker's bell in place of the
 * v1 notification modal.
 */
export default {
  name: 'NotificationPopover',
  components: {
    TickerPopover,
  },
  props: {
    left: {
      type: Number,
      default: 0,
    },
    arrowLeft: {
      type: Number,
      default: 24,
    },
  },
  computed: {
    ...mapGetters('announcement', ['announcements']),
    ...mapGetters('general', ['timezone']),
  },
  methods: {
    renderDateTime(value) {
      return this.$moment(new Date(value)).tz(this.timezone).format('DD/MM/YYYY - HH:mm');
    },
  },
};
</script>

<style lang="scss" scoped>
/*
 * Measured from Figma node 763:1179. The newest item is white with a gold
 * timestamp and a 4px dot; everything already read is #A1BBC9 throughout. Text
 * is 11px on an 18px line, and the 12px inset matches the header's.
 */
.notification-popover__list {
  margin: 0;
  padding: 0 12px;
  list-style: none;
}

.notification-popover__item {
  padding: 12px 0;

  & + & {
    border-top: 1px solid #19253c;
  }
}

.notification-popover__time {
  color: #a1bbc9;
  font-size: 11px;
  font-weight: 500;
  line-height: 13px;
}

.notification-popover__message {
  margin: 10px 0 0;
  color: #a1bbc9;
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.notification-popover__item.latest {
  .notification-popover__time {
    // The dot takes the 12px column and the date follows 8px later, which is
    // the 24px the design puts it at.
    color: #efc87f;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
      content: '';
      flex: 0 0 4px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #efc87f;
    }
  }

  .notification-popover__message {
    color: #fff;
  }
}
</style>
